// extracted by mini-css-extract-plugin
export default {"routineblock":"GQ","container":"HQ","carousel":"IQ","routine":"JQ","heading":"KQ","routinelist":"LQ","routineitem":"MQ","routineimg":"NQ","routinedesc":"OQ","routinename":"PQ","routinetext":"QQ","carouselwrap":"RQ"};
    if(module.hot) {
      // 1713996749008
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  